import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=1b72a986&scoped=true"
import script from "./Profiles.vue?vue&type=script&lang=js"
export * from "./Profiles.vue?vue&type=script&lang=js"
import style0 from "./Profiles.vue?vue&type=style&index=0&id=1b72a986&prod&lang=less&scoped=true"
import style1 from "./Profiles.vue?vue&type=style&index=1&id=1b72a986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72a986",
  null
  
)

export default component.exports